module.exports = new __parcel__URL__("gra2pes--dataset-cover.9c510604.png").toString();